
import { Vue, Component, Prop } from "vue-property-decorator";
import { TemplatePreviewableItem } from "@/types/templates";

@Component
export default class PreviewChooserItem extends Vue {
  @Prop()
  item!: TemplatePreviewableItem;

  @Prop()
  selected!: boolean;
}
